import React, {Fragment} from "react"
import CommonCounter from "./CommonCounter"

const counterContent = [
    {
        num: "125",
        mark: "+",
        desc: "Hemos Desarrollado Más de 125+ Software"
    }, {
        num: "64",
        mark: "+",
        desc: "Clientes Globales que Confían en Nosotros"
    }, {
        num: "32",
        mark: "+",
        desc: "Premios Ganados Locales y Globales"
    }, {
        num: "122",
        mark: "+",
        desc: "Clientes Reseñan Nuestro Software"
    }
]

const CounterTwoA = () => {
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5">
                {counterContent.map((val, i) => (
                    <div key={i} className="col-lg-3 col-md-6 col-sm-6" data-aos="fade-up">
                        <div
                            className="counter-style-two boder-style d-xxl-flex align-items-center mb-45">
                            <h3>
                                <span className="counter"><CommonCounter value={val.num} /></span>{val.mark}</h3>
                            <p className="text-white">{val.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default CounterTwoA